export default __webpack_public_path__ + "static/media/intro-precog.50c498de.png";